export const HIDE_NEW_POST_MESSAGE = 'newPostMessage/HIDE';
export const HIDE_NEW_POST_MESSAGE_DEBOUNCED = 'newPostMessage/HIDE_DEBOUNCED';

export const hideNewPostMessage = () => dispatch => {
  dispatch({
    type: HIDE_NEW_POST_MESSAGE,
  });
};

export const hideNewPostMessageDebounced = debounce => {
  const action = hideNewPostMessage();
  action.type = HIDE_NEW_POST_MESSAGE_DEBOUNCED;
  action.meta = { debounce };

  return action;
};



// WEBPACK FOOTER //
// ./app/actions/hide-new-post-message.js